import React from "react";

const MobileCategories = ({
  categories,
  activeCategoryId,
  setActiveCategoryId,
}) => {
  return (
    <div className="md:hidden overflow-x-auto mb-6 w-full">
      <div className="flex gap-2 px-2 w-full">
        {categories.map((cat) => (
          <button
            key={cat._id} // ✅ use ID
            onClick={() => setActiveCategoryId(cat._id)} // ✅ use ID
            className={`flex-shrink-0 px-4 py-2 rounded-full text-sm font-medium whitespace-nowrap ${
              activeCategoryId === cat._id
                ? "bg-navy font-medium text-yellowstar"
                : "text-textGray hover:bg-gray-100"
            }`}
            style={activeCategoryId === cat._id ? { color: cat.color } : {}}
          >
            {cat.name}
            <span
              className="ml-1 text-xs"
              style={activeCategoryId === cat._id ? { color: cat.color } : {}}
            >
              ({cat.count})
            </span>
          </button>
        ))}
      </div>
    </div>
  );
};

export default MobileCategories;

// import React from "react";

// const MobileCategories = ({
//   categories,
//   activeCategory,
//   setActiveCategory,
//   activeCategoryId, // ✅ use ID
//   setActiveCategoryId, // ✅ use ID
// }) => {
//   return (
//     <div className="md:hidden overflow-x-auto mb-6 w-full">
//       <div className="flex gap-2 px-2 w-full">
//         {categories.map((cat) => (
//           <button
//             key={cat.name}
//             onClick={() => setActiveCategory(cat.name)}
//             className={`flex-shrink-0 px-4 py-2 rounded-full text-sm font-medium whitespace-nowrap  ${
//               activeCategory === cat.name
//                 ? "bg-drylight font-medium "
//                 : "text-textGray hover:bg-gray-100"
//             }`}
//             style={
//               activeCategory === cat.name
//                 ? { color: cat.color } // use backend color
//                 : {}
//             }
//           >
//             {cat.name}{" "}
//             <span
//               className={`ml-1 text-xs
//     }
//   `}
//               style={
//                 activeCategory === cat.name
//                   ? { color: cat.color } // use backend color
//                   : {}
//               }
//             >
//               ({cat.count})
//             </span>
//           </button>
//         ))}
//       </div>
//     </div>
//   );
// };

// export default MobileCategories;
